const A = "inserted", c = "removed", u = "not-to-inject", s = (e) => ({
  reviveId: (e == null ? void 0 : e.getAttribute("reviveid")) || (e == null ? void 0 : e.getAttribute("data-reviveid")) || (e == null ? void 0 : e.getAttribute("data-revive-id")) || "",
  zoneId: (e == null ? void 0 : e.getAttribute("zoneid")) || (e == null ? void 0 : e.getAttribute("data-revivezoneid")) || (e == null ? void 0 : e.getAttribute("data-revive-zoneid")) || ""
}), I = (e, t) => {
  const n = document.createElement("ins");
  return n.setAttribute("data-revive-zoneid", t), n.setAttribute("data-revive-id", e), n.setAttribute("style", "display: none"), n;
}, o = ({ zoneId: e, action: t, fullscreen: n }) => {
  setTimeout(
    () => {
      var i;
      (i = window.manipulateBanner) == null || i.call(window, e, t, n);
    },
    n ? 1e3 : 0
  );
}, p = (e) => e.dataset.state !== A && e.dataset.state !== u, w = (e) => e.dataset.state !== c, y = (e, t) => {
  const { reviveId: n, zoneId: i } = s(e), r = I(n, i);
  t ? t.appendChild(r) : e.appendChild(r);
}, T = (e, t) => {
  var n;
  if (typeof window.reviveAsync > "u")
    console.info("[SKY-ADV - INIT] window.reviveAsync is undefined");
  else {
    const { reviveId: i } = s(e);
    (n = window.reviveAsync[i]) == null || n.apply(window.reviveAsync[i].detect()), e.dataset.state = A, t == null || t();
  }
}, z = (e, t) => {
  const { zoneId: n } = s(e);
  o({ zoneId: n, action: "refresh", fullscreen: t });
}, E = (e) => {
  const { zoneId: t } = s(e);
  o({
    zoneId: t,
    action: "destroy"
    /* DESTROY */
  }), e.dataset.state = c;
};
export {
  E as destroyAdv,
  T as initAdv,
  y as injectAdv,
  z as refreshAdv,
  p as shouldInjectAdv,
  w as shouldRemoveAdv
};
